module.exports = __webpack_public_path__ + "img/400.b651d3cd.jpg";